import React from "react";
import "./App.css";
import { LanguageProvider } from "./contexts/LanguageContext";
import Home from "./pages/Home";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <Home />
      </LanguageProvider>
    </div>
  );
}

export default App;
